import { render, staticRenderFns } from "./GroupContact.vue?vue&type=template&id=55268b2d&scoped=true&"
import script from "./GroupContact.vue?vue&type=script&lang=js&"
export * from "./GroupContact.vue?vue&type=script&lang=js&"
import style0 from "./GroupContact.vue?vue&type=style&index=0&id=55268b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55268b2d",
  null
  
)

export default component.exports